import Button from 'components/formElements/Button'
import moment from 'moment'
import {Calendar} from 'primereact/calendar'
import {Dropdown} from 'primereact/dropdown'
import {InputNumber} from 'primereact/inputnumber'
import { PropTypes } from 'prop-types'
import {useSelector} from 'react-redux'
import { currencyTypes, responsibleRoles } from 'utils/Constants'

const AddInvoiceModalContent = ({ formData, handleChange, handleSubmit, setModalOpen, submitLoading }) => {
	const { invoiceStatuses } = useSelector((state) => state.projectDetail)
	return (
		<div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
			<div className="row">
			<div className='col-md-12'>
					<div className='form-control'>
						<input className='default-input' placeholder='Proje Adımı' name='name' type='text' onChange={(e) => handleChange(e.target.value, 'name')} />
					</div>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-6'>
					<div className='form-control'>
						<Dropdown placeholder='Sorumlu Kişi' value={formData.responsibleRole && formData.responsibleRole} options={responsibleRoles} onChange={(e) => handleChange(e.value, 'responsibleRole')} />
					</div>
				</div>
				<div className="col-md-6">
					<Dropdown
					optionLabel='label'
					optionValue='value'
					placeholder='Fatura Durumu'
					value={formData?.invoiceStatusId && formData.invoiceStatusId}
					options={invoiceStatuses?.filter(s => (!s.label.includes('Ödendi') && !s.label.includes('Kesildi')))}
					onChange={(e) => {handleChange(e.value,'invoiceStatusId')}}
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-6'>
					<div className='form-control'>
						<Calendar
							view="month" 
							dateFormat="mm/yy"
							placeholder='Kesilecek Ay/Yıl'
							value={formData?.estimatedDate && moment(formData?.estimatedDate).locale('en')._d}
							onChange={(e) => {
								handleChange( moment(e.target.value).add(3, 'hours').toISOString(),'estimatedDate')
							}}
						/>
					</div>
				</div>
				<div className='col-md-6'>
					<div className='form-control'>
						<InputNumber mode="decimal" max={100} value={formData?.percent} onBlur={e =>handleChange(e.target.value, 'percent')} placeholder='Ödeme Yüzdesi' name='percent' onChange={(e) => handleChange(e.value, 'percent')} />
					</div>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-6'>
					<div className='form-control'>
						<InputNumber mode="decimal" minFractionDigits={2} placeholder='Tutar' name='amount' value={formData?.amount && formData.amount} onChange={(e) => handleChange(e.value, 'amount')}  />
					</div>
				</div>
				<div className='col-md-6'>
					<div className='form-control'>
						<Dropdown placeholder='Para Birimi' value={formData?.currency && formData.currency} optionLabel='label' optionValue='value' options={currencyTypes} onChange={(e) => handleChange(e.value, 'currency')} />
					</div>
				</div>
			</div>
			<div className='row justify-content-center'>
				<div className='col-md-3'>
					<Button handleClick={handleSubmit} disabled={submitLoading} className='btn-success w-100 justify-content-center' title={'Ekle'} />
				</div>
				<div className='col-md-3'>
					<Button
						handleClick={() => setModalOpen((prev) => ({ ...prev, step: 1,width:'70%' }))}
						className='btn-danger-outline w-100 justify-content-center'
						title={'Vazgeç'}
					/>
				</div>
			</div>
		</div>
	)
}

AddInvoiceModalContent.propTypes = {
	setModalOpen: PropTypes.func,
	formData: PropTypes.obj,
	handleSubmit: PropTypes.func,
	handleChange: PropTypes.func,
	removeFile: PropTypes.func,
}

export default AddInvoiceModalContent
